module.exports = __webpack_public_path__ + "static/media/generic-token-logo.c73674bb.png";